import { render, staticRenderFns } from "./service.vue?vue&type=template&id=7266446d&scoped=true&"
import script from "./service.vue?vue&type=script&lang=ts&"
export * from "./service.vue?vue&type=script&lang=ts&"
import style0 from "./service.vue?vue&type=style&index=0&id=7266446d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7266446d",
  null
  
)

export default component.exports